import React , {useState} from 'react';
import PropTypes from 'prop-types';
import ModalVideo from 'react-modal-video';
import 'react-modal-video/scss/modal-video.scss' ;
import './styles.scss'
import {Image} from "react-bootstrap";

SliderItem.propTypes = {
    item : PropTypes.object,
};

function SliderItem(props) {
    const {item} = props;
    const [isOpen, setOpen] = useState(false)

    return (
        <div className={`box-slider ${item.classAction}`}>
            <div className='bg-slider' style={{backgroundImage: `url(${item.bgImg})`}} />
            <div className="box-slider__main">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 col-md-12">
                            <div className="content-box">
                                <h1 className="title">{item.title}</h1>
                                <p className="sub-title">{item.desc}</p>
                                <div className="wrap-btn">
                                    <button to="#" className="tf-button-st2 btn-effect popup-youtube" onClick={()=> setOpen(true)}>
                                        <span className="boder-fade"></span>
                                        <span className="effect">watch video</span>
                                    </button>
                                    <a href="https://mint.dinocpp.com/" target="_blank" rel="noreferrer" className="tf-button btn-effect">
                                        <span className="boder-fade"></span>
                                        <span className="effect">mint page</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-md-12">
                            <div className="image">
                                <Image src={item.item} alt="slide DinoCpp" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ModalVideo channel='youtube' autoplay isOpen={isOpen} videoId="OvUT1LIKDoU" onClose={() => setOpen(false)} />
        </div>
    );
}

export default SliderItem;